var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf1Left(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 249.58 327.27",
    style: {
      enableBackground: "new 0 0 249.58 327.27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94.77,271.8c-17.51-3.33-35.74-5.65-50.78-17.59c-9.67-7.68-17.3-16.81-22.26-28.2 c14.43,14.19,34.19,19.84,50.1,31.59c4.63,3.42,9.39,6.65,14.08,9.97c0.44-0.31,0.89-0.61,1.33-0.92c-0.76-1.52-1.15-3.45-2.33-4.5 c-11.88-10.55-17.2-24.12-18.91-39.55c-0.69-6.25-2.01-12.44-1.98-19.3c3.11,5.97,6.68,11.75,9.21,17.95 c4.02,9.84,7,20.1,11.08,29.91C87.29,258.33,91.31,265.06,94.77,271.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.09,237.81c-11.94-9.48-24.45-18.35-35.68-28.62C9.74,198.52,3.45,184.62,3.18,168.23 c4.83,11.96,14.76,19.82,22.66,29.33c7.8,9.39,14.75,19.48,22.07,29.26c0.63-0.25,1.25-0.49,1.88-0.74 c-0.25-1.72,0.04-3.82-0.85-5.09c-8.36-11.89-7.47-25.19-6.03-38.52c0.65-6.05,1.95-12.03,3.1-18.9 c7.81,24.17,2.79,49.64,12.18,72.66C57.83,236.76,57.46,237.29,57.09,237.81z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.49,285.36c-12.08,2.92-22.87,5.59-33.69,8.13c-18.12,4.26-44.05-4.62-54.37-17.87 c8.61,1.76,18,4.23,27.54,5.5c12.01,1.6,24.15,2.17,36.22,3.28c3.37,0.31,6.71,0.99,10.34,0.85c-7.04-6.84-18.65-6.39-24.2-15.2 c-5.08-8.07-9.85-16.35-14.76-24.53c0.56-0.43,1.11-0.85,1.67-1.28c2.65,2.5,5.39,4.92,7.93,7.53c4.29,4.41,8.49,8.92,12.67,13.45 C122.08,274.16,131.78,280.96,144.49,285.36z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.4,177.19c-6.21-22.73,2.19-41.65,14.37-59.51c0.55,23.72-11.85,45.04-12.99,68.19 c-20.1-20.49-31.66-44.3-26.7-74.65c4.87,19.47,16.56,36.01,18.63,55.91c0.37,3.58,2.5,6.98,3.81,10.47 C27.48,177.46,28.44,177.33,29.4,177.19z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.4,74.67c-2.75,6.12-4.97,12.54-8.36,18.28c-5.07,8.59-11.13,16.59-16.42,25.06 c-2.78,4.45-4.81,9.38-7.49,14.71c-4.32-17.54-13.26-33.44-11.59-51.86c0.84-9.25,3.45-17.83,8.68-26.8 c0.74,18.56,1.49,36.03,2.07,53.52c0.11,3.31-0.59,6.64-0.63,9.96c-0.01,0.9,1.03,1.82,1.59,2.73c0.79-0.69,1.61-1.36,2.35-2.1 c0.2-0.2,0.19-0.63,0.23-0.96C27.93,98,41.36,86.27,55.4,74.67z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.44,305.81c13.22,2.5,25.83,1.69,38.23-3.65c11.73-5.05,23.51-10.15,35.65-14.01 c10.1-3.21,20.65-1.89,30.84,1.39c-3.39-0.32-6.78-0.91-10.16-0.89c-9.11,0.05-16.56,4.03-23.31,9.92 c-8.97,7.82-18.65,14.64-30.61,16.97C116.09,318.45,102.54,314.76,90.44,305.81z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.85,22.68c-4.31,16.95-8.72,34.25-13.12,51.56c0.37,0.05,0.74,0.09,1.11,0.14 c5.58-6.81,10.64-14.15,16.87-20.29c6.24-6.15,13.64-11.11,20.56-16.6c-1.33,6.48-5.36,11.83-9.79,16.74 c-4.56,5.06-9.67,9.62-14.63,14.32c-4.92,4.66-9.94,9.21-16.19,14.99c0-11.96-0.66-22.88,0.18-33.69 C31.72,38.6,37.62,29.51,45.85,22.68z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.33,42.28C54.19,21.08,64.55,8.56,84.88,0C79.25,12.64,63.57,31.92,50.33,42.28z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.58,322.87c-1.64,1.84-3.03,3.4-3.93,4.4c-13.82-12.01-27.18-23.62-40.55-35.24 C222.15,298.77,236.64,309.51,249.58,322.87z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf1Left);
export default __webpack_public_path__ + "static/media/leaf1_left.20e08bf30ca489585f70bcc2ecdffcfe.svg";
export { ForwardRef as ReactComponent };